import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=10657404&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Logo.vue?vue&type=style&index=1&id=10657404&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10657404",
  null
  
)

export default component.exports